// removed by extract-text-webpack-plugin
module.exports = {"boxClassroom":"src-components-ContentBox-BoxClassroom-__style-module___boxClassroom","boxClassroomData":"src-components-ContentBox-BoxClassroom-__style-module___boxClassroomData","details":"src-components-ContentBox-BoxClassroom-__style-module___details","classYear":"src-components-ContentBox-BoxClassroom-__style-module___classYear","memberCount":"src-components-ContentBox-BoxClassroom-__style-module___memberCount","selected":"src-components-ContentBox-BoxClassroom-__style-module___selected"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentBox/BoxClassroom/style.module.css
// module id = 154
// module chunks = 0